import { render, staticRenderFns } from "./Page7.vue?vue&type=template&id=af1350ac&scoped=true&"
import script from "./Page7.vue?vue&type=script&lang=js&"
export * from "./Page7.vue?vue&type=script&lang=js&"
import style0 from "./Page7.vue?vue&type=style&index=0&id=af1350ac&prod&lang=css&"
import style1 from "./Page7.vue?vue&type=style&index=1&id=af1350ac&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "af1350ac",
  null
  
)

export default component.exports